import React from 'react-redux';
import CellName from './Cells/CellName';
import CellEnabled from './Cells/CellEnabled';
import CellStatus from './Cells/CellStatus';
import CellAlgoNo from './Cells/CellAlgoNo';
import CellAlertNo from './Cells/CellAlertNo';
import CellType from './Cells/CellType';
import CellDateCreated from './Cells/CellDateCreated';
import CellExpiry from './Cells/CellExpiry';
import CellAction from './Cells/CellAction';
import CellEntrySigCount from './Cells/CellEntrySigCount';
import CellExitSigCount from './Cells/CellExitSigCount';

export const columns = [
  {
    Header: 'Enable',
    width: 90,
    minWidth: 80,
    accessor: 'enabled',
    Cell: ({ row = {} }) => <CellEnabled row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Signal name',
    accessor: 'name',
    width: 325,
    minWidth: 225,
    Cell: ({ row = {} }) => <CellName row={row} />,
    innerDivProps: {
      dataKey: 'name',
      isSortable: true,
    },
  },
  {
    Header: 'Type',
    accessor: 'type',
    width: 150,
    minWidth: 150,
    Cell: ({ row = {} }) => <CellType row={row} />,
    innerDivProps: {
      dataKey: 'type',
      isSortable: true,
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 150,
    minWidth: 150,
    Cell: ({ row = {} }) => <CellStatus row={row} />,
    innerDivProps: {
      dataKey: 'status',
      isSortable: true,
    },
  },
  {
    Header: 'No. of Alerts',
    accessor: 'signalCount',
    width: 150,
    minWidth: 150,
    cellProps: {
      align: 'center',
    },
    Cell: ({ row = {} }) => <CellAlertNo row={row} />,
    innerDivProps: {
      dataKey: 'signalCount',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Linked algos',
    accessor: 'linkedAlgoCount',
    width: 150,
    minWidth: 150,
    cellProps: {
      align: 'center',
    },
    Cell: ({ row = {} }) => <CellAlgoNo row={row} />,
    innerDivProps: {
      dataKey: 'linkedAlgoCount',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Entry signals',
    accessor: 'entrySigCount',
    width: 150,
    minWidth: 150,
    cellProps: {
      align: 'center',
    },
    Cell: ({ row = {} }) => <CellEntrySigCount row={row} />,
    innerDivProps: {
      dataKey: 'entrySigCount',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Exit signals',
    accessor: 'exitSigCount',
    width: 150,
    minWidth: 150,
    cellProps: {
      align: 'center',
    },
    Cell: ({ row = {} }) => <CellExitSigCount row={row} />,
    innerDivProps: {
      dataKey: 'exitSigCount',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    width: 80,
    minWidth: 80,
    Cell: ({ row = {} }) => <CellAction row={row} />,
    innerDivProps: {
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Date created',
    accessor: 'createdAt',
    width: 170,
    minWidth: 170,
    cellProps: {
      align: 'center',
    },
    Cell: ({ row = {} }) => <CellDateCreated row={row} />,
    innerDivProps: {
      dataKey: 'createdAt',
      isSortable: true,
      innerDivStyle: { justifyContent: 'center' },
    },
  },
  {
    Header: 'Listen till',
    accessor: 'expiry',
    width: 170,
    minWidth: 170,
    cellProps: {
      align: 'center',
    },
    Cell: ({ row = {} }) => <CellExpiry row={row} />,
    innerDivProps: {
      dataKey: 'expiry',
      isSortable: true,
    },
  },
];
